import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setLocale, Translate} from 'react-redux-i18n';
import MenuItem from '@material-ui/core/MenuItem';
import {TextField} from '@material-ui/core';
import Input from '@material-ui/core/Input';
import {availableLanguages} from '../../../translations';
import * as snackbarsActions from '../../../actions/snackbars';
import {captureError} from '../../../utils/log';
import userService from '../../../services/user/UserService';

function LanguageForm() {
  const [currentLocale, user] = useSelector(state => [
    state.i18n.locale,
    state.user
  ]);
  const dispatch = useDispatch();
  const [language, setLanguage] = React.useState(currentLocale);

  function handleLanguageChange(event) {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);
    userService.updateLanguage(user.id, newLanguage)
      .then(() => {
        dispatch(setLocale(newLanguage));
        dispatch(snackbarsActions.addSuccess(<Translate value="message.changesSaved"/>));
      })
      .catch(error => {
        captureError('userService.updateLanguage', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  return (
    <div className="inline-container col-md-4">
      <TextField
        select
        input={<Input
          name="language"
          id="language"
        />}
        value={language}
        onChange={handleLanguageChange}
      >
        {availableLanguages.map((lang, index) => (
          <MenuItem
            key={index}
            value={lang}
          >
            <Translate value={`language.${lang}`}/>
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}

export default LanguageForm;
